<!-- 用户编辑弹窗 -->
<template>
  <a-modal
    :width="580"
    :visible="visible"
    :confirm-loading="loading"
    :title="isUpdate ? '修改信息' : '新建信息'"
    :body-style="{ paddingBottom: '8px' }"
    @update:visible="updateVisible"
    @ok="save"
  >
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ md: { span: 7 }, sm: { span: 24 } }"
      :wrapper-col="{ md: { span: 17 }, sm: { span: 24 } }"
    >
      <a-row :gutter="16">
        <a-col :md="20" :sm="24" :xs="24">
          <a-form-item label="appId:" name="appId">
            <a-input
              allow-clear
              placeholder="请输入appId"
              v-model:value="form.appId"
            />
          </a-form-item>
          <a-form-item label="标题:" name="title">
            <a-input
              allow-clear
              placeholder="请输入标题"
              v-model:value="form.title"
            />
          </a-form-item>
          <a-form-item label="显示:" name="isShow">
            <a-select
                allow-clear
                placeholder="状态查询"
                v-model:value="form.isShow"
              >
                <a-select-option
                  v-for="item in stateDict"
                  :key="item.dictDataCode"
                  :value="item.dictDataCode"
                >
                  {{ item.dictDataName }}
                </a-select-option>
              </a-select>
          </a-form-item>
          <a-form-item label="分组:" name="groupCode">
            <a-select
              allow-clear
              placeholder="请选择分组"
              v-model:value="form.groupCode"
            >
              <a-select-option
                v-for="item in groupCodeDict"
                :key="item.dictDataCode"
                :value="item.dictDataCode"
              >
                {{ item.dictDataName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="排序:" name="sortNumber">
            <a-input-number
              style="width: 100%"
              allow-clear
              placeholder="排序"
              v-model:value="form.sortNumber"
            />
          </a-form-item>
          <a-form-item label="图片:" name="url">
            <a-input
              allow-clear
              placeholder="请上传图片"
              v-model:value="form.url"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="flex" justify="center">
        <a-col>
          <a-upload
            list-type="picture-card"
            v-model:file-list="imgList"
            @preview="handlePreview"
            :customRequest="({ file }) => uploadFile(file, 'url')"
            :remove="removeFile"
          >
            <div v-if="imgList.length < 1">
              <plus-outlined />
              <div class="ant-upload-text">背景图</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import setting from '@/config/setting'
import * as appBannerApi from '@/api/sys/appBanner'
import * as dictDataApi from '@/api/sys/dictData'
export default {
  name: 'bannersEdit',
  emits: ['done', 'update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({}, this.data),
      imgList: [],
      heros: [
        {
          name: '',
          idcard: ''
        }
      ],
      uploadUrl: setting.uploadUrl,
      // 表单验证规则
      rules: {},
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      previewVisible: false,
      previewImage: '',
      // 状态字典项
      stateDict: [],
      groupCodeDict:[]
    }
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data)
        if (this.form.heros) {
          this.heros = JSON.parse(this.form.heros)
        }
        if (this.form.url) {
          this.imgList = [{ url: this.form.url }]
        }

        this.isUpdate = true
      } else {
        this.form = {
          corpId: this.getCorpId()
        }
        this.isUpdate = false
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    }
  },
  mounted() {
    this.form.corpId = this.getCorpId()
    this.queryDataStates()
    this.queryAppNavGroupCode()
  },
  methods: {
    /* 保存编辑 */
    save() {
      if(!this.isUpdate){
        this.form.corpId = this.getCorpId()
      }
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true
          appBannerApi
            .save(this.form, this.isUpdate)
            .then((res) => {
              this.loading = false
              if (res.code === 0) {
                console.log(res.code)
                this.$message.success(res.msg)
                if (!this.isUpdate) {
                  this.form = {}
                }
                this.updateVisible(false)
                this.$emit('done')
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch((e) => {
              this.loading = false
              this.$message.error(e.message)
            })
        })
        .catch(() => {})
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    },
    // 删除图片
    removeFile(file) {
      console.log('file', file.url)
      this.$http
        .delete('/file/remove', {
          path: file.url
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.form.url = ''
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 导航分组典项
    queryAppNavGroupCode() {
      dictDataApi
        .querydictdata('navGroup', this.form.corpId)
        .then((res) => {
          if (res.code === 0) {
            this.groupCodeDict = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    },
    // 上传图片
    uploadFile(file, name) {
      const formData = new FormData()
      formData.append('file', file)
      const hide = this.$message.loading('上传中..', 0)
      this.$http
        .post(this.uploadUrl, formData)
        .then((res) => {
          hide()
          if (res.data.code === 0) {
            if (name === 'url') {
              this.imgList[0] = {
                uid: '-4',
                name: 'image.png',
                status: 'done',
                url: res.data.location
              }
            }
            this.form[name] = res.data.location
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((e) => {
          hide()
          this.$message.error(e.message)
        })
      return false
    },
    handlePreview(file) {
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      this.fileList = fileList
    },
    handleCancel() {
      this.previewVisible = false
    },
    // 状态字典项
    queryDataStates() {
      dictDataApi
        .querydictdata('isShow')
        .then((res) => {
          if (res.code === 0) {
            this.stateDict = res.data
            this.stateDict.map((item) => {
              item.dictDataCode = parseInt(item.dictDataCode)
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((e) => {
          this.$message.error(e.message)
        })
    }
  }
}
</script>

<style scoped>
</style>
